import {TreeViewItem} from '../@types/tree-view-item';
import {getPathToRootAsArrayOfString, role} from './group-utils';
import {BreadCrumbsProp} from '../@types/bread-crumb';
import {getResourceNameWithAscendants} from './resource-utils';
import {ResourceType} from '../@types/resource-type';
import OccurrenceReportDescriptor from '../@types/occurrence-report-descriptor';


export function occurrenceReportDescriptorTreeItems(descriptors: OccurrenceReportDescriptor[]): TreeViewItem[] {
    return descriptors.map((oc: OccurrenceReportDescriptor) => occurrenceReportDescriptorTreeItem(oc, role(oc.group),
        getResourceNameWithAscendants(oc.group, ResourceType.GROUPS)))
}

const occurrenceReportDescriptorTreeItem = (descriptor: OccurrenceReportDescriptor, role: string, path: string): TreeViewItem => {
    let obj: TreeViewItem = {
        id: descriptor.id!.toString(),
        object: descriptor,
        name: `${descriptor.name}`,
        description: descriptor.description,
        status: descriptor.descriptorState,
        uri: descriptor.uri,
        groupPath: path,
        groupRole: role,
        type: ResourceType.OCCURRENCE_REPORT_DESCRIPTORS,
        hasChildren: false,
        sortField: descriptor.name
    };
    if (descriptor.version) {
        obj.version = descriptor.version;
    }
    return obj;
}

export function makeOccurrenceReportDescriptor(descriptor: any): OccurrenceReportDescriptor {
    let ord: OccurrenceReportDescriptor = {} as OccurrenceReportDescriptor;
    ord.id = descriptor.id;
    ord.name = descriptor.name;
    ord.description = descriptor.description;
    ord.uri = descriptor.uri;
    ord.descriptorState = descriptor.status;
    ord.descriptorTerms = descriptor.descriptorTerms || [];
    ord.group = descriptor.group;
    return ord;
}

export function getOccurrenceReportDescriptorPathToRootAsArrayOfString(ord: OccurrenceReportDescriptor): Array<BreadCrumbsProp> {
    let path: Array<BreadCrumbsProp> = [];
    if (ord.id) {
        path = getPathToRootAsArrayOfString(ord.group);
    }

    return [...path, {
        id: ord.id,
        label: ord.name && ord.name !== '' ? ord.name : 'New Occurrence Report Descriptor',
        type: ResourceType.OCCURRENCE_REPORT_DESCRIPTORS
    }];
}
